import ObjectID from 'bson-objectid';

export const generateDbId = () => new ObjectID();
